<template>
    <form method='POST' v-on:submit.prevent="handleSubmit">
        <div class='m-portlet__body'>
            <div class='m-form__section'>
                <div class='m-form__heading'>
                    <h3 class='m-form__heading-title'>
                        Prefix Settings
                    </h3>
                </div>
                <div class='form-group m-form__group row'>
                    <div class='col-lg-6 m-form__group-sub'>
                        <label for='route'>
                            Route
                        </label>
                        <input type='text' class='form-control m-input' id='route' v-model="prefix"
                               placeholder='Enter route'>
                        <span class='m-form__help'>
                        We'll never share your email with anyone else.
                    </span>
                    </div>
                </div>
            </div>
        </div>
        <Buttons v-on:save="save" :list-link="`/admin/modules/index`"></Buttons>
    </form>
</template>

<script>
import Buttons from '../../core/form/Buttons'
export default {
  name: 'ModuleUpdatePrefix',
  components: {Buttons},
  data () {
    return {
      prefix: ''
    }
  },
  watch: {
    'prefix': {
      handler (val) {
        if (val !== undefined && val.startsWith('/') === false) {
          this.prefix = '/' + this.prefix
        }
      },
      deep: true
    }
  },
  methods: {
    handleSubmit () {
      this.$http
        .put(process.env.API_URL + `/api/v1/admin/module-builder/update-prefix`, {
          prefix: this.prefix,
          moduleName: this.$route.params.id
        }, {
          'headers': {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'language': this.$store.state.loading.language
          }
        }).then(res => {
          if (res.data && res.data.data !== 'undefined') {
            this.$router.push('/admin/modules/index')
          } else {
            this.errors = res.response.data.errors
          }
        }).catch(res => {

        })
    }
  },
  mounted: function () {
    this.$emit('updateTitle', 'Update Prefix')

    let self = this
    this.$http
      .get(process.env.API_URL + `/api/v1/admin/module-builder/show/${this.$route.params.id}`, {
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        self.prefix = res.data.data.route
      }).catch(res => {

      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/module/ModuleUpdatePrefix.vue